module.exports = __webpack_public_path__ + "img/AI (3).ca16d859.png";